import { render } from "./TopRatedToday.vue?vue&type=template&id=2809fc73&ts=true"
import script from "./TopRatedToday.vue?vue&type=script&lang=ts"
export * from "./TopRatedToday.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__